import fiscalInstance from '../../instance'

const getReportZip = (reportId) => {
	return fiscalInstance.get('/cashRegisterClose/reports/' + reportId + '/zip',
		{ responseType: 'arraybuffer' })
}

export default getReportZip
